import * as React from 'react';
import { fairPlayIcon } from '../../../icons';
import { ErrorWrapper } from '../../ErrorWrapper';

export const Success = () => {
  return (
    <ErrorWrapper icon={fairPlayIcon}>
      Запрос на&nbsp;участие в&nbsp;программе «Работаю&nbsp;честно» отправлен. Ожидайте ответа в&nbsp;течение суток
    </ErrorWrapper>
  );
};
